import React, { useEffect,useState } from 'react'
import { all_routes } from '../../../router/all_routes'
import { Link } from 'react-router-dom'
import Table from "../../../../core/common/dataTable/index";
import CollapseHeader from '../../../../core/common/collapse-header/collapse-header';
import useFetch from '../../../../hooks/useFetch';
import { API } from '../../../../common/Constants';
import { getAPIHeaders, getFormattedDateDDMMYYYY, isBeforeCurrentDate, isCurrentDateInBetween, toCamelCase } from "../../../../common/Utils";
import OnboardStudent from './onboardStudent';
import ModifyStudent from './modifyStudent';
import PreLoader from '../../../../core/common/preLoader';
import { Student } from '../../../../types/dataModel';
import CopyRightInfo from '../../../../core/common/copyRightInfo';
import { useAccess } from '../../../../hooks/accessContext';
import DropDown from '../../../../core/common/commonDropDown';
import PropomoteStudent from './promoteStudent';


const Students = () => {
  const { hasClassMgntCreate, hasClassMgntEdit } = useAccess()
  const { isLoading, callFetch } = useFetch();
  const [students, setStudents] = useState<Student[]>([]);
  const [classOpts, setClassOpts] = useState<any[]>([]);
  const [editStudent, setEditStudent] = useState<Student>();
  const [stats, setStats] = useState<any>();
  const [filters, setFilters] = useState({ batchName: '', status: '' });
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [viewType, setViewType] = useState<'table' | 'card'>('table');


  useEffect(() => {
    fetchStudents()
    fetchClasses()
    }, []);

  const handleFilterChange = (filterType: string, value: string) => {
    setFilters((prevFilters) => ({ ...prevFilters, [filterType]: value }));
  };

  const filteredStudents = students?.filter((student) => {
    return (
      (filters.batchName
        ? `${student.batchId}` === filters.batchName
        : true) &&
      (filters.status ? student.curriculumStatus === filters.status : true)
    );
  }) || [];

  const clearAllFilters = () => {
    setFilters({ batchName: '' , status: '' });
  };

  const fetchStudents = () => {
    callFetch(API.STUDENTS,
      'GET',
      getAPIHeaders(),
      null,
      null
    ).then((res)=>{
      setStudents(res?.studentProfiles || [])
      setStats(res?.studentStatsCard)
    });
  }

  const fetchClasses = () => {
    callFetch(API.CLASS_SUBJECT,
      'GET',
      getAPIHeaders(),
      null,
      null
    ).then((res)=>{
      setClassOpts(parseToClassOpts(res))
    });
  }

  const renderPromoteModal = () => {
    return (
      <PropomoteStudent 
        classOpts={classOpts} 
        selectedStudents={selectedRowKeys} 
        onSuccess={()=>{
          fetchStudents()
          setSelectedRowKeys([])
        }}
      />
    );
  };


  const columns = [
    {
      title: "ID",
      dataIndex: "studentBatchId",
      render: (text: String, record: any) => (
        <span className='text-dark'>{text}</span>
      ),
      sorter: (a: any, b: any) => a.studentBatchId - b.studentBatchId,
    },
    {
      title: "Name",
      dataIndex: "firstName",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          {record.profilePictureUrl ? (
            <div className="avatar avatar-md me-2">
              <img 
                src={record.profilePictureUrl} 
                alt={`${record.firstName} ${record.lastName}`}
                className="avatar-img rounded-circle"
              />
            </div>
          ) : (
            <div className="avatar avatar-md me-2 bg-light-primary rounded-circle">
              <span className="text-primary fw-bold">
                {record.firstName.charAt(0).toUpperCase()}{record.lastName.charAt(0).toUpperCase()}
              </span>
            </div>
          )}
          <div className="ms-2">
            <p className="text-dark mb-0">
              <h6 className="fw-medium student-title">
                <Link 
                  to="#" 
                  className="text-reset text-decoration-none"
                  onClick={() => { setEditStudent(record) }}
                  data-bs-toggle="modal"
                  data-bs-target="#edit_employee"
                >
                  {record.firstName} {record.lastName}
                </Link>
              </h6>
            </p>
            <div className="d-flex align-items-center mt-1 student-info">
              <span className="badge badge-soft-primary me-2">
                {record.gender === 'M' ? 'Male': record.gender === 'F' ? 'Female' :record.gender === 'O' ? 'Other' :""}
              </span>
            </div>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.firstName.localeCompare(b.firstName),
    },
    {
      title: "Batch",
      dataIndex: "batchName",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.batchName} {record.batchSection}
            </p>
            <div className="d-flex align-items-center mt-1 batch-info">
              <span className="badge badge-soft-primary me-2">Roll No: {record.rollNumber}</span>
            </div>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.batchName.localeCompare(b.batchName),
      defaultSortOrder: 'ascend',
    },
    {
      title: "Course",
      dataIndex: "courseTitle",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.courseTitle}
            </p>
            <span className="fs-12">{record.curriculumTitle} </span>
            <p className="fs-12 fw-bold text-dark mb-0">Status:
              {isCurrentDateInBetween(record.curriculumStartDate, record.curriculumEndDate)
                ?
                <span className='text-success'> Live</span>
                : isBeforeCurrentDate(record.curriculumEndDate) ?
                  <span className='text-danger'> Inactive </span>
                  : <span className='text-info'> Upcoming</span>
              }
              <span className='ms-1 text-dark fs-10 align-self-center'>({getFormattedDateDDMMYYYY(record.curriculumStartDate)} - {getFormattedDateDDMMYYYY(record.curriculumEndDate)})</span>
            </p>
          </div>
      </div>
      ),
      sorter: (a: any, b: any) => a.courseTitle.localeCompare(b.courseTitle),
    },
    {
      title: "Status",
      dataIndex: "curriculumStatus",
      sorter: (a: any, b: any) => a.curriculumStatus.localeCompare(b.curriculumStatus),
      render: (text: string) => (
        text === 'ACTIVE' ?
          <span className="badge badge-soft-success d-inline-flex align-items-center badge-sm">
              {text}
          </span>
          :
          text === 'INACTIVE' ?
          <span className="badge badge-soft-danger d-inline-flex align-items-center badge-sm">
            {text}
          </span>
          :
          <span className="badge badge-soft-info d-inline-flex align-items-center badge-sm">
            {text}
          </span>
        
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.username}
            </p>
            <div className="d-flex align-items-center mt-1">
              <span className="badge badge-soft-primary me-2">Acct# {record.accountId}</span>
            </div>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.username.localCompare(b.username.length),
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a: any, b: any) => a.email.localCompare(b.email.length),
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      sorter: (a: any, b: any) => a.phoneNumber - b.phoneNumber,
    },
    {
      title: "Actions",
      dataIndex: "",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            hidden={!hasClassMgntEdit()}
            to="#"
            className="me-2 icon-edit"
            data-bs-toggle="modal" data-inert={true}
            data-bs-target="#edit_employee"
            onClick={()=>{setEditStudent(record)}}
            title="Edit Student"
          >
            <i className="ti ti-edit" />
          </Link>
        </div>
      ),
    },
  ]


  const renderAddStudent = () => {
    return (
        <OnboardStudent classOpts={classOpts} onSuccess={fetchStudents}/>
    )
  }

  const renderEditStudent = () => {
    return (
        <ModifyStudent 
          classOpts={classOpts}
          student={editStudent}
          onSuccess={fetchStudents}
        />
    )
  }

  const renderStatCards = () => {
    return (
      <div className="row">
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Total Students</p>
                        <h4>{stats?.totalStudents}</h4>
                    </div>
                    <div><span className="p-2 br-10 bg-transparent-primary border border-primary d-flex align-items-center justify-content-center"><i className="ti ti-user text-primary fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Male / Female Students</p>
                        <h4>{stats?.maleStudents} / {stats?.femaleStudents} </h4>
                    </div>
                    <div><span className="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center"><i className="ti ti-user text-success fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Students Continued with Us</p>
                        <div className='d-flex flex-row'><h4>{stats?.activeStudents}</h4> <span className='fs-12 ms-1 align-self-center'>(New Admissions:<span className='text-dark text-center'>{stats?.newAdmissionsInLastOneMonth}</span>)</span></div>
                    </div>
                    <div><span className="p-2 br-10 bg-transparent-purple border border-purple d-flex align-items-center justify-content-center"><i className="ti ti-user text-purple fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Students Discontinued</p>
                        <h4>{stats?.inactiveStudents}</h4>
                    </div>
                    <div><span className="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center"><i className="ti ti-user-exclamation text-danger fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    )
  }

  const renderFilters = () => {
    return (
      <div className="d-flex align-items-center gap-3 flex-wrap">
      {/* Batch Name Filter */}
      <div className="d-flex align-items-center">
        <DropDown onChange={(val)=>{handleFilterChange('batchName', val)}} 
          defaultValue={''}
          options={[{label: 'All Batches', value:''},...classOpts]}
          value={filters.batchName}
        />
      </div>
      {/* Status Filter */}
      <div className="d-flex align-items-center">
        <DropDown onChange={(val)=>{handleFilterChange('status', val)}} 
          defaultValue={''}
          value={filters.status}
          options={[
            {value:'', label:'All Status'},
            {value:'ACTIVE', label: 'Active'}, 
            {value: 'INACTIVE', label:'Inactive'},
            {value: 'UPCOMING', label:'Upcoming'},
          ]}
        />
      </div>
      {/* Clear All Filters Button */}
      <button
        className="btn btn-outline-secondary btn-sm"
        onClick={() => clearAllFilters()}
      >
        Clear All Filters
      </button>
    </div>
    )
  }

  return (
    <>
      <PreLoader showLoader={isLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Students</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Learning Center</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Students
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              <div className="mb-2">
                <button
                  disabled={!hasClassMgntCreate()}
                  data-bs-toggle="modal" data-inert={true}
                  data-bs-target="#add_student"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Student
                </button>
              </div>
              <div className="mb-2">
                <button
                  disabled={!hasClassMgntCreate() || !selectedRowKeys.length}
                  className="btn btn-primary d-flex align-items-center"
                  data-bs-target="#promote_student"
                  data-bs-toggle="modal" data-inert={true}
                >
                  <i className="ti ti-arrow-up-right me-2" />
                  Promote Students
                </button>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {renderStatCards()}
          <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5>Student List</h5>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <div className="view-toggle">
              <button 
                className={`btn btn-sm me-2 ${viewType === 'table' ? 'btn-primary' : 'btn-outline-primary'}`} 
                onClick={() => setViewType('table')}
                aria-label="Switch to table view"
              >
                <i className="ti ti-table me-1"></i> Table View
              </button>
              <button 
                className={`btn btn-sm ${viewType === 'card' ? 'btn-primary' : 'btn-outline-primary'}`} 
                onClick={() => setViewType('card')}
                aria-label="Switch to card view"
              >
                <i className="ti ti-layout-grid me-1"></i> Card View
              </button>
            </div>
            {renderFilters()}
          </div>
        </div>
            <div className="card-body p-0">
              {viewType === 'table' ? (
                <Table 
                  dataSource={filteredStudents} 
                  columns={columns} 
                  rowKey="studentBatchId"
                  Selection={true} 
                  refresh={fetchStudents}
                  onRowSelectionChange={(selectedKeys) => {
                    setSelectedRowKeys(selectedKeys)
                  }}
                  rowSelection={{
                    selectedRowKeys,
                    onChange: (selectedKeys) => {
                      setSelectedRowKeys(selectedKeys);
                    },
                  }}
                />
              ) : (
                <div className="student-cards p-3">
                  <div className="row">
                    {filteredStudents.map((student: any) => (
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3" key={student.studentBatchId}>
                        <div className="card h-100 border shadow-sm">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div className="d-flex align-items-center">
                                {student.profilePictureUrl ? (
                                  <div className="avatar avatar-lg me-3 flex-shrink-0">
                                    <img 
                                      src={student.profilePictureUrl} 
                                      alt={`${student.firstName} ${student.lastName}`}
                                      className="avatar-img rounded-circle"
                                    />
                                  </div>
                                ) : (
                                  <div className="avatar avatar-lg me-3 flex-shrink-0 bg-light-primary rounded-circle">
                                    <span className="text-primary fw-bold">
                                      {student.firstName.charAt(0).toUpperCase()}
                                    </span>
                                  </div>
                                )}
                                <h6 className="mb-0 fw-semibold student-title">
                                  {student.firstName} {student.lastName}
                                </h6>
                              </div>
                              <div>
                                <span className="badge badge-soft-primary">Roll No: {student.rollNumber}</span>
                              </div>
                            </div>
                            
                            <div className="d-flex justify-content-between mb-3">
                              <div>
                                <div className="fs-12 fw-medium text-dark">Batch</div>
                                <div className="fs-12">{student.batchName} {student.batchSection}</div>
                              </div>
                              <div>
                                <div className="fs-12 fw-medium text-dark">Gender</div>
                                <div className="fs-12">
                                  {student.gender === 'M' ? 'Male' : student.gender === 'F' ? 'Female' : student.gender === 'O' ? 'Other' : ""}
                                </div>
                              </div>
                            </div>
                            
                            <div className="student-info mb-3">
                              <div className="fs-12 fw-medium text-dark mb-1">Course</div>
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="fs-12">{student.courseTitle}</div>
                                <span className="fs-12 text-muted">{student.curriculumTitle}</span>
                              </div>
                            </div>
                            
                            <div className="student-dates mb-3">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <div className="fs-12 fw-medium text-dark">Start Date</div>
                                  <div className="fs-12">{getFormattedDateDDMMYYYY(student.curriculumStartDate)}</div>
                                </div>
                                <div>
                                  <div className="fs-12 fw-medium text-dark">End Date</div>
                                  <div className="fs-12">{getFormattedDateDDMMYYYY(student.curriculumEndDate)}</div>
                                </div>
                                <div>
                                  <div className="fs-12 fw-medium text-dark">Status</div>
                                  <div>
                                    {student.curriculumStatus === 'ACTIVE' ? (
                                      <span className="badge badge-soft-success badge-sm">Active</span>
                                    ) : student.curriculumStatus === 'INACTIVE' ? (
                                      <span className="badge badge-soft-danger badge-sm">Inactive</span>
                                    ) : (
                                      <span className="badge badge-soft-info badge-sm">Upcoming</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="student-status fs-12 mb-3">
                              <div className="fw-medium text-dark mb-1">Current Status:</div>
                              {isCurrentDateInBetween(student.curriculumStartDate, student.curriculumEndDate) ? (
                                <div className="d-flex align-items-center">
                                  <span className="dot-indicator bg-success me-1"></span>
                                  <span className="text-success">Live</span>
                                </div>
                              ) : isBeforeCurrentDate(student.curriculumEndDate) ? (
                                <div className="d-flex align-items-center">
                                  <span className="dot-indicator bg-danger me-1"></span>
                                  <span className="text-danger">Inactive</span>
                                </div>
                              ) : (
                                <div className="d-flex align-items-center">
                                  <span className="dot-indicator bg-info me-1"></span>
                                  <span className="text-info">Upcoming</span>
                                </div>
                              )}
                            </div>
                            <div className="student-account mb-3">
                              <div className="row">
                                <div className="col-6">
                                  <div className="fs-12 fw-medium text-dark">Username</div>
                                  <div className="fs-12 text-truncate">{student.username}</div>
                                </div>
                                <div className="col-6">
                                  <div className="fs-12 fw-medium text-dark">Account ID</div>
                                  <div className="fs-12">
                                    <span className="badge badge-soft-primary">Acct# {student.accountId}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="student-contact mb-3">
                              <div className="row">
                                <div className="col-6">
                                  <div className="fs-12 fw-medium text-dark">Email</div>
                                  <div className="fs-12 text-truncate">{student.email}</div>
                                </div>
                                <div className="col-6">
                                  <div className="fs-12 fw-medium text-dark">Phone</div>
                                  <div className="fs-12">{student.phoneNumber}</div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="d-flex justify-content-end mt-3">
                              <Link
                                hidden={!hasClassMgntEdit()}
                                to="#"
                                className="btn btn-sm btn-outline-primary"
                                data-bs-toggle="modal" data-inert={true}
                                data-bs-target="#edit_employee"
                                onClick={() => setEditStudent(student)}
                                title="Edit Student"
                              >
                                <i className="ti ti-edit me-1" /> Edit
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <CopyRightInfo/>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Student */}
      {renderAddStudent()}
      {/* /Add Student */}
      {/* Edit Student */}
      {renderEditStudent()}
      {/* /Edit Student */}
      {renderPromoteModal()}
    </>

  )
}

function parseToClassOpts(data: any[]) {
  let classes: any[] = []
  if (data) {
    data.forEach((item) => {
      if (item.curriculumStatus !== "INACTIVE") {
        let existing = classes.find((el: any, idx) => `${item.batchId}` === el.value)
        if (!existing) {
          classes.push({
            label: `${item.batchName}-${item.batchSection}-${item.courseTitle}`,
            value: `${item.batchId}`,
            curriculumStatus: item.curriculumStatus,
            data: item
          })
        }
      }
    })
  }
  return classes
}

export default Students